import Stream from '../libs/Stream';


let updatePhoneActionStream: Stream<string> = new Stream() as Stream<string>;

export default updatePhoneActionStream;
